export default {
  title: 'Tilauslaskut',
  list: {
    empty_list: {
      title: 'Ei vielä tilauslaskuja.',
    },
    fields: {
      id: 'Tunnus',
      total: 'Yhteensä',
      date: 'Päivämäärä',
    },
  },
  export_modal: {
    title: 'Suodatin',
    start_date: {
      title: 'Alkupäivä',
      placeholder: 'päivämäärä',
    },
    end_date: {
      title: 'Loppupäivä',
      placeholder: 'päivämäärä',
    },
    button: {
      title1: 'Käytä',
      title2: 'Sulje',
    },
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
};
